import React from 'react';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons';
import {Button} from '@mui/material';
import {
	FallbackMessage,
	FallbackMessageProps,
} from '@netx/core-components/FallbackMessage';
import {AuthMessage, AuthActionLabel} from '../../locales';

export interface ResetPasswordRequestSuccessProps extends FallbackMessageProps {
	onCancel?: () => void;
}

export const ResetPasswordRequestSuccessPrimitive = ({
	onCancel,
	...props
}: ResetPasswordRequestSuccessProps) => {
	return (
		<FallbackMessage
			icon={faCheckCircle}
			variant="light"
			title={AuthMessage.PASSWORD_RESET_SENT}
			{...props}
		>
			<Button
				variant="text"
				onClick={() => {
					onCancel?.();
				}}
			>
				{AuthActionLabel.RETURN_TO_LOGIN}
			</Button>
		</FallbackMessage>
	);
};

export const ResetPasswordRequestSuccess = ResetPasswordRequestSuccessPrimitive;

export default ResetPasswordRequestSuccess;
